import { useEffect, useState } from 'react';

export const useIsServerSideRendered = () => {
    const [isServerSideRendered, setIsServerSideRendered] = useState(true);

    useEffect(() => {
        setIsServerSideRendered(false);
    }, []);

    return { isServerSideRendered };
};
